import React, { lazy, Suspense, useState } from 'react';

import FitmentShell, {
  FitmentShellProps
} from './components/fitment-shell/fitment-shell';

import { useSmartLoader } from '../../shared/hooks/hooks';

const Fitment = lazy(async () => {
  const module = await import(
    /* webpackChunkName: "fitment" */
    '../fitment/fitment'
  );
  // slight delay to stop flicker during transition
  await new Promise(resolve => setTimeout(resolve, 50));

  return module;
});

interface FitmentSmartLoaderProps extends FitmentShellProps {
  onAddVehicleClicked?: () => void;
  onShopProducts?: () => void;
  selectedTab?: string;
}

function FitmentSmartLoader(props: FitmentSmartLoaderProps) {
  const { selectedTab } = props;
  const [initialFitmentTab, setInitialFitmentTab] = useState(selectedTab);
  const [shouldAutofocusYear, setShouldAutofocusYear] = useState(false);
  const [shouldAutofocusLicensePlate, setShouldAutofocusLicensePlate] =
    useState(false);
  const { shouldLoadComponent, setShouldLoadComponent } = useSmartLoader();

  function onTabSelected(tab) {
    setInitialFitmentTab(tab);
    setShouldLoadComponent(true);
  }

  function onFocusDropdown() {
    setShouldAutofocusYear(true);
    setShouldLoadComponent(true);
  }

  function onFocusLicensePlateDropdown() {
    setShouldAutofocusLicensePlate(true);
    setShouldLoadComponent(true);
  }

  return (
    <>
      {!shouldLoadComponent && (
        <FitmentShell
          {...props}
          onFocusDropdown={onFocusDropdown}
          onFocusLicensePlateDropdown={onFocusLicensePlateDropdown}
          onTabSelected={onTabSelected}
        />
      )}

      {shouldLoadComponent && (
        <Suspense fallback={<FitmentShell {...props} />}>
          <Fitment
            {...props}
            selectedTab={initialFitmentTab}
            shouldAutofocusLicensePlate={shouldAutofocusLicensePlate}
            shouldAutofocusYear={shouldAutofocusYear}
          />
        </Suspense>
      )}
    </>
  );
}

export default FitmentSmartLoader;
